import React from 'react';
import ChatWindow from '@components/Chat/ChatWindow';
import { LanguageProvider } from '@/contexts/LanguageContext';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="app">
        <ChatWindow isWidget={false} />
      </div>
    </LanguageProvider>
  );
}

export default App;




